export default __webpack_public_path__ + "static/media/ic_lock_2.65a81c15.svg";